module.exports = __webpack_public_path__ + "chris-fce993c98996780deeb7da871bf55181.jpg";